export const styles = {
  image: {
    width: "144px",
    height: "60px",
  },
};
